export default {
  statusNone: 'No subscription',
  statusTrialing: 'Free trial',
  statusActive: 'Active',
  statusPastDue: 'Payment failed',
  statusCanceled: 'Cancelled',
  statusIncomplete: 'Incomplete',
  statusIncompleteExpired: 'Checkout expired',
  statusExpired: 'Trial ended',
  monthly: 'Monthly',
  annualSave: 'Annual · save {percent}%',
  intervalLabel: 'Billing interval',
  subscriptionStarted: 'Subscription started — welcome to CrewPresence.',
  eyebrow: 'Manage',
  title: 'Billing',
  description: 'CrewPresence is $11 per active employee, per month, with a 14-day free trial. Pay annually and save {percent}%.',
  activeEmployees: 'Active employees',
  pricePerEmployee: 'Price per employee',
  perYear: '{price}/yr',
  perMonth: '{price}/mo',
  annualDiscountHint: '{percent}% off the monthly price',
  estimatedYearly: 'Estimated yearly cost',
  estimatedMonthly: 'Estimated monthly cost',
  freeUntilTrialEnds: 'Free until your trial ends',
  subscription: 'Subscription',
  seatsAutoUpdate: 'Seats update automatically as you add or remove employees.',
  trialEndsManual: 'Your free trial ends {date}. Nothing is charged until you subscribe.',
  trialEndsCard: 'Your free trial ends {date}. Your card will then be charged automatically.',
  trialEnded: 'Your free trial has ended. Subscribe to continue.',
  opening: 'Opening…',
  manageBilling: 'Manage billing',
  starting: 'Starting…',
  subscribe: 'Subscribe',
  startTrial: 'Start 14-day free trial',
}
